import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { AppRoot } from './app';

import './app/app.css';

/**
 * FE1-W0 application bootstrap.
 *
 * RESPONSIBILITY: mount React. That is all. There is no business logic here, no
 * data access, no transport, no routing and no state — the composition root is
 * `frontend/src/portals/PortalRoot.tsx`.
 *
 * A missing mount element is a FRONTEND BOOTSTRAP DEFECT, not a read-model state.
 * It throws rather than rendering a fallback, because a fallback would present an
 * unmounted application as a mounted one. It is deliberately not reported as
 * UNKNOWN, EMPTY, ERROR-as-a-contract-state or UNAVAILABLE.
 */

const MOUNT_ELEMENT_ID = 'root';

const mountElement = document.getElementById(MOUNT_ELEMENT_ID);

if (mountElement === null) {
  throw new Error(
    `FE1-W0 bootstrap defect: the mount element #${MOUNT_ELEMENT_ID} is absent from the ` +
      'document. This is a frontend bootstrap failure, not a read-model state.',
  );
}

createRoot(mountElement).render(
  <StrictMode>
    <AppRoot />
  </StrictMode>,
);
